import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import EmptyCargoSVG from "../../../media/images/icons/empty-cargo";
import { blueGrey } from "@mui/material/colors";

interface Props {
  description: string;
}

export default function EmptyListBox(props: Props) {
  const { description } = props;

  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: "1",
        overflow: "hidden",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          height: "200px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
        <Typography
          maxWidth={150}
          textAlign={"center"}
          sx={{
            fontWeight: "700",
            color: blueGrey[500],
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
